import model from './model';

export default model.createController(() => {
  return {
    pageReady: async () => {},
    exports: {},
  };
});
